<template>
	<vx-card
        v-if="
                $store.state.auth.role === 'manager' || $store.state.auth.role === 'admin'
                || $store.state.auth.role === 'supervisor'
            "
    >
		<div class="vx-row">
            <div  @click="disableEditing" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('informationAboutOrder') }}</div>
			<div @click="enableEditing" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('editInformationAboutOrder') }}</div>
            <div @click="openComment" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('commentAboutOrder') }}
				<span
                    v-if="countOrderComments > 0"
                    class="status text-sm"
                >
                    {{ countOrderComments }}
                </span>
			</div>
			<div class="vx-col pt-2 pb-4"
			>
                <strong>{{ $t('taskAboutOrder') }} </strong>
				<span
                    v-if="countOrderTasks.count > 0"
                    class="status text-sm"
                    :class="{ markedDelay: countOrderTasks.delay > 0 }"
                >
                    {{ countOrderTasks.count }}
                </span>
            </div>
		</div>
		<hr class="mb-3">
        <div v-if="listTasks.length > 0">
            <template 
                v-for="(data, index) in listTasks"
            >
                <div :class="{ marked: isMarked(data) }">
                    <div class="mb-1 frsTitileOrderComment">
                        <div 
                            v-if="data.userRole != 'unknowUserRole' && data.userRole != 'unknowUserName'" 
                            class="frsUserOrderComment"
                        >
                            {{ $t(data.userRole) }}: <strong>{{ data.userName }}</strong>
                        </div>
                        <div 
                            v-else 
                            class="frsUserOrderComment"
                        >
                            {{ $t('systemTypeEvent') }}
                        </div>
                        <div class="frsDateOrderComment">{{ data.dateEvent }}</div>
                    </div>
                    <div class="mb-1 frsTitileOrderComment" v-if="data.isExpired > 0">
                        <div 
                            v-if="$store.state.auth.role === 'admin' && data.userRole != 'unknowUserRole' && data.userRole != 'unknowUserName'" 
                            class="frsUserOrderComment"
                        >
                            {{ $t(data.userRole) }}: <strong>{{ data.userName }}</strong>
                        </div>
                        <div 
                            v-else 
                            class="frsUserOrderComment"
                        >
                            <div v-if="$store.state.auth.role === 'admin'">
                                {{ $t('systemTypeEvent') }}
                            </div>
                        </div>
                        <div class="frsIsExpired">{{ $t('isExpired') }}</div>
                        <div class="frsDateOrderComment frsIsExpired">{{ data.dateTimeClose }}</div>
                    </div>
                    <div v-if="data.description != '' && data.userRole != 'author'" 
                        :class="{ notRelevant: isNotRelevant(data), crossedOut: isCrossedOut(data) }"
                        class="mb-1 frsTextOrderComment"
                    >
                        {{ $t(data.description) }}
                    </div>
                    <div v-if="data.userRole == 'author'" class="mb-1 frsTextOrderComment">
                        {{ $t('needAuthorPutPage') }}: {{ $t(data.description) }}
                    </div>
                    <div class="mb-1 frsTextOrderComment">
                        <div class="list-item-btn-bottom">
                            <vs-checkbox
                                @click.stop
                                @input="dlgCompletedTask = true, currentTaskId = data.id"
                                v-model="data.is_completed"
                                class="ml-auto pr-2 pl-2"
                            ></vs-checkbox>
                            <feather-icon
                                v-if="$store.state.auth.role === 'admin'"
                                @click.stop="dlgDeleteTask = true, currentTaskId = data.id"
                                icon="Trash2Icon"
                                size="'30'"
                                svgClasses="h-4 w-4"
                                class="ml-auto pr-2 pl-2"
                            />
                            <feather-icon
                                v-if="$store.state.auth.role === 'manager'"
                                @click.stop="dlgNotRelevantTask = true, currentTaskId = data.id"
                                icon="Trash2Icon"
                                size="'30'"
                                svgClasses="h-4 w-4"
                                class="ml-auto pr-2 pl-2"
                            />
                        </div>
                    </div>
                    <hr class="mb-3 mt-3">
                </div>
                <ModalDeleteTask
                    :active.sync="dlgDeleteTask"
                    @accept="deleteTask"
                />
                <ModalNotRelevantTask
                    :active.sync="dlgNotRelevantTask"
                    @accept="notRelevantTask"
                />
                <ModalCompletedTask
                    :active.sync="dlgCompletedTask"
                    @accept="changeTaskState(true)"
                    @cancel="changeTaskState(false)"
                />
            </template>
        </div>
        <div v-else class="text-center">
            {{ $t('noOrderTask') }}
        </div>
    </vx-card>
</template>

<script>
    import axios from "@/axios";
    import moment from 'moment';
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";
    import ModalDeleteTask from "@/components/dialogs/ModalDeleteTask";
    import ModalNotRelevantTask from "@/components/dialogs/ModalNotRelevantTask";
    import ModalCompletedTask from "@/components/dialogs/ModalCompletedTask";

    export default {
        name: "CardTicketTask",
        mixins: [databaseManager, notifier],
        props: {
            model: 		            { default: null },
            countOrderComments:     { default: null },
            countOrderTasks:     { default: null },
        },
        components: {
            ModalDeleteTask,
            ModalNotRelevantTask,
            ModalCompletedTask,
        },
        data() {
            return {
                listTasks:  { default: [] },
                currentTaskId: null,
                dlgDeleteTask: false,
                dlgNotRelevantTask: false,
                dlgCompletedTask: false,
           };
        },
        methods: {
            async changeTaskState (e) {
                if (e) {
                    let res = await axios.post('/'+this.$store.state.auth.role+'/task/complete/'+this.currentTaskId,{is_completed: true});

                    this.notifySuccess(this.$t("completedTaskNotification"));
                } else {
                    this.data.is_completed = 0;
                    // this.$store.dispatch('calendar/reopenTask', this.data);
                }
                await this.getOrderTask();
            },
            async deleteTask() {
                try {
				    let res = await axios.post('/'+this.$store.state.auth.role+'/task/delete/'+this.currentTaskId);

                    this.notifySuccess(this.$t("deleteTaskNotification"));
                } catch (e) {
                    this.notifyError(this.$t('errorNotification'));
                }
                await this.getOrderTask();
            },
            async notRelevantTask() {
                try {
                    await this.dbNotRelevantTask(this.currentTaskId);

                    this.notifySuccess(this.$t("switchStatusTaskNotRelevantNotification"));
                } catch (e) {
                    this.notifyError(this.$t('errorNotification'));
                }
                await this.getOrderTask();
            },
            disableEditing() {
                this.$emit("disableEditingOrder");
            },
            enableEditing() {
                this.$emit("enableEditingOrder");
            },
            openComment() {
                this.$emit("showOrderComment");
            },
            async getOrderTask() {
                this.listTasks = await this.dbViewOrderTasks(this.$route.params.id);
            },
            isNotRelevant(item) {
                if(item.isNotRelevant == 0) {
                    return false;
                } else {
                    return true;
                }
            },
            isCrossedOut(item) {
                if(item.is_completed == 0) {
                    return false;
                } else {
                    return true;
                }
            },
            isMarked(item) {
                const taskDate = item.dateEvent;
                const currentDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                if(item.is_completed == 0 && item.isNotRelevant == 0) {
                    return currentDate > taskDate;
                } else {
                    return false;
                }
            },
        },
        async mounted() {
            try {
                await this.getOrderTask();
            } catch(e) {
                this.notifyError(e.message);
            }
        },
    }
</script>

<style lang="scss">
    .frsIsExpired {
        color: red;
        font-weight: bolder;
    }
    .list-item-btn-bottom {
        display: flex;
        margin-left: auto;
    }
    .crossedOut {
        text-decoration: line-through;
		background-color: #9bfa7e;
    }
	.notRelevant {
        text-decoration: line-through;
		background-color: #f3e84e;
	}
	.marked {
		background-color: #F4A9A9 !important;
	}
	.markedDelay {
		background-color: red !important;
	}
    .frsTitileOrderComment {
        display: flex;
        width: 100%;
    }
    .frsTextOrderComment {
        width: 100%;
    }
    .frsUserOrderComment {
        padding: 0 5px 0 0;
    }
    .frsDateOrderComment {
        margin-left: auto;
        padding: 0 0 0 5px;
    }
    .affair-list-item {
	background-color: red;
	padding: 1rem;
	width: 100%;
	display: flex;
	cursor: pointer;
	flex-direction: column;
	background-color: #f1f1f166;
	border-top: 1px solid #ddd;

	&.marked {
		background-color: #F4A9A9;
	}

	.completed {
		text-decoration: line-through;
	}

	&:last-of-type{
		border-bottom: 1px solid #ddd;
	}

	.list-item-top {
		display: flex;
		flex-grow: 1;

		b {
			flex-grow: 1;
		}

		.controls-wrapper {
			display: flex;
			align-items: center;
			margin-bottom: 8px;
		}

		&__right {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 20px;
			height: 20px;
		}
	}

	.list-item-bottom {
		display: flex;

		.description-wrapper {
			display: flex;
			flex-grow: 1;

			&__text {
				word-break: break-word;
			}

			b {
				margin-right: 1rem;
			}

		}

		.provided-by-admin {
			font-size: 10px;
			width: 15%;
			margin-right: 10px;
		}
	}

	.vs-checkbox {
		background-color: white;
		border-color: #6f6f6f !important;
	}
}

</style>